<template>
  <div>
    <el-main style="padding: 0">
      <view-table
          ref="viewTable"
          :filter="filter"
          :columns-property="columnsProperty"
          module="basic"
          url="scanRecords"
          @reset="resetHandle">
        <template slot="adSearch">
          <el-form :inline="true" :model="filter" @keyup.enter.native="loadData(1)">
            <el-form-item label="条码">
              <el-input v-model.trim="filter.boxCode" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="类型">
              <el-select v-model.trim="filter.insertType" clearable>
                <el-option label="外购入库" :value="30"/>
                <el-option label="调拨出库" :value="50"/>
                <el-option label="领料出库" :value="60"/>
              </el-select>
            </el-form-item>
            <el-form-item label="物料编号">
              <el-input v-model.trim="filter.materialNo" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="物料名称">
              <el-input v-model.trim="filter.materialName" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="规格型号">
              <el-input v-model.trim="filter.specification" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="关联单据">
              <el-input v-model.trim="filter.repairOrder" placeholder="请输入" clearable/>
            </el-form-item>
            <el-form-item label="扫描日期">
              <el-date-picker
                  v-model="createDateRange"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始时间"
                  end-placeholder="结束时间"
                  value-format="yyyy-MM-dd"
                  @change="dateRangeChange('createDateRange', 'addDateBegin', 'addDateEnd')"/>
            </el-form-item>
          </el-form>
        </template>
      </view-table>
    </el-main>
  </div>
</template>

<script>
  import ViewTable from "@/components/ViewTable.vue";

  export default {
    name: "ScanRecordList",
    components: {ViewTable},
    data() {
      return {
        filter: {
          materialNo: "",
          materialName: "",
          specification: "",
          boxCode: "",
          repairOrder: "",
          insertType: "",
          addDateBegin: "",
          addDateEnd: "",
        },
        createDateRange: [],
        columnsProperty: [
          {
            key: "materialNo",
            align: "center",
          },
        ],
      };
    },
    watch: {
      "filter.addDateBegin": {
        handler(newVal) {
          if (newVal) {
            this.createDateRange = [];
            this.createDateRange.push(this.filter.addDateBegin);
            this.createDateRange.push(this.filter.addDateEnd);
          }
        },
      },
    },


    methods: {
      loadData(pageNum) {
        this.$refs.viewTable.loadData(pageNum);
      },
      // 重置
      resetHandle(filter) {
        this.filter = Object.assign(this.filter, filter);
      },
      dateRangeChange(timeRange, timeStart, timeEnd) {
        if (this[timeRange]) {
          this.filter[timeStart] = this[timeRange][0];
          this.filter[timeEnd] = this[timeRange][1];
        } else {
          this.filter[timeStart] = "";
          this.filter[timeEnd] = "";
        }
      },
    },
  };
</script>
